import React from "react"
import PropTypes from "prop-types"

import moment from "moment"
import classnames from "classnames"

import appStorage from "@cirrus/legacy/app-components/app-settings/index.es6"
import DatePicker from "@cirrus/legacy/app-components/datetime/datepicker/index.jsx"
import Link from "@cirrus/legacy/app-components/links/index.jsx"

import styles from "./index.less"

function makeStartDate(date) {
  if (!date) return date
  return moment(date).startOf("day").toDate()
}

function makeEndDate(date) {
  if (!date) return date
  return moment(date).endOf("day").toDate()
}

let IntervalDatepicker = (props) => {
  let { startDate, endDate, onStartDateChange, onEndDateChange, onIntervalChange, format } = props

  let datePickerFormat = moment().localeData(format)._longDateFormat.L

  let handleStartDateChange = (date) => onStartDateChange(makeStartDate(date))
  let handleEndDateChange = (date) => onEndDateChange(makeEndDate(date))

  let onIntervalLinkClick = ({ days }) => {
    let endDate = makeEndDate(new Date())
    let startDate = makeStartDate(moment(endDate).subtract(days, "d").toDate())

    onIntervalChange({ startDate, endDate })
  }

  let dateIsNotValid = endDate && startDate && startDate > endDate

  return (
    <div className={styles.container}>
      <div className={styles.itemLabel}>
        <label className={styles.label}>{appStorage.translationFunction("General:Between")}</label>
      </div>
      <div className={styles.itemDatepicker}>
        <DatePicker
          value={makeStartDate(startDate)}
          className={props.className}
          format={datePickerFormat}
          editFormat={datePickerFormat}
          onChange={handleStartDateChange}
          max={
            endDate
              ? endDate
              : undefined /* this is done because if null is passed to "max" property, selection of current date doesn't work properly for some reason */
          }
          isNotValid={dateIsNotValid}
          data-qa="datepickerStartDateInput"
        />
      </div>
      <div className={styles.itemLabel}>
        <label className={styles.label}>
          {appStorage.translationFunction("General:AndLowerCase")}
        </label>
      </div>
      <div className={styles.itemDatepicker}>
        <DatePicker
          value={makeEndDate(endDate)}
          className={props.className}
          format={datePickerFormat}
          editFormat={datePickerFormat}
          onChange={handleEndDateChange}
          min={startDate}
          isNotValid={dateIsNotValid}
          data-qa="datepickerEndDateInput"
        />
      </div>
      <div className={styles.itemLabel7}>
        <Link
          className={styles.link}
          onClick={() => onIntervalLinkClick({ days: 6 })}
          dataQa="selectWeekIntervalLink">
          {appStorage.translationFunction("Framework.DateFilter:LastXDay").replace("{0}", "7")}
        </Link>
      </div>
      <div className={styles.itemLabel30}>
        <Link
          className={styles.link}
          onClick={() => onIntervalLinkClick({ days: 29 })}
          dataQa="selectMonthIntervalLink">
          {appStorage.translationFunction("Framework.DateFilter:LastXDay").replace("{0}", "30")}
        </Link>
      </div>
    </div>
  )
}

IntervalDatepicker.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
  onIntervalChange: PropTypes.func,
}

export default IntervalDatepicker
